var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountPausedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 93,
    viewBox: "0 0 118 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1679 85.4726C14.2161 83.918 1.71284 64.9154 1.06474 58.8505C-0.0867584 48.0751 11.192 42.2634 21.9613 41.0558C24.8914 40.7272 27.9646 39.6334 31.5346 36.1713C36.6419 31.2183 40.5543 26.0068 44.8032 20.2609C48.4739 15.2971 52.177 11.7166 56.3457 7.52573C67.7963 -3.98604 75.5263 -1.44519 87.4015 9.4171C96.7545 17.9723 110.817 33.4285 115.542 50.9514C120.268 68.4743 115.542 103.63 72.8858 82.9864C43.0926 68.5682 55.5081 105.666 17.1679 85.4726Z",
    fill: "#FFECEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 22L47.5 92",
    stroke: "#FF627E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9995 52.0005L47.2137 55.83C46.155 56.1241 45.0573 55.509 44.7554 54.4524L35.4013 21.7167C35.1025 20.6712 35.7066 19.5819 36.7521 19.2832C44.4174 17.0928 54.866 14.1072 61.5444 12.1989C63.5358 11.6298 65.6094 12.7834 66.1784 14.7748V14.7748C66.7474 16.7662 65.5944 18.8418 63.603 19.4108L60.4781 20.3037C58.354 20.9107 57.1241 23.1247 57.731 25.2488V25.2488C58.338 27.3729 60.552 28.6028 62.6761 27.9959L82.8679 22.2261L77.7174 38.7782",
    stroke: "#FF627E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.612 51.1727L71.7855 55.9809C69.1303 56.7396 66.3628 55.2022 65.6041 52.547L57.999 25.9321",
    stroke: "#FF627E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPausedIcon);
export default __webpack_public_path__ + "static/media/account-paused-icon.f32fbd810521131a4d8d16fd6c472e84.svg";
export { ForwardRef as ReactComponent };